function calculateExactAge(birthDate) {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

function calculateNearestAge(birthDate) {
    let ageNearest = calculateExactAge(birthDate);
    const today = new Date();
    let birthdayPassed = true;

    if (today.getMonth() < birthDate.getMonth() || 
        (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
        birthdayPassed = false;
    }

    let previousBirthdayYear = today.getFullYear() - (birthdayPassed ? 0 : 1);
    let previousBirthday = new Date(birthDate.setFullYear(previousBirthdayYear));
    let sixMonthBirthday = new Date(previousBirthday.setMonth(previousBirthday.getMonth() + 6));

    if (sixMonthBirthday <= today) {
        ageNearest += 1;
    }

    return ageNearest;
}

export {
    calculateExactAge,
    calculateNearestAge,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Helpers/AgeCalculation.js